export default {
  placeholder: 'Buscar negocio...',
};
